import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { CarouselBase } from '../../lit-mixins/carousel-base/index.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { getGenericCarouselSettings } from '../../molecules/generic-carousel/utils/settings.js';
import '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z$1 from '../../molecules/generic-carousel/generic-carousel.scss.js';
import css_248z from './cards-gallery-plus.scss.js';
import { CardsGalleryPlusHeadlineAlign, CardsGalleryPlusHeadlineColor, CardsGalleryPlusHeadlineSize, CardsGalleryPlusTemplateType, CardsGalleryPlusDisplayType } from './enums.js';

let uidCounter = 0;
const LitElementWithUtils = BaseWithUtils(s);
let CardsGalleryPlus = class CardsGalleryPlus extends CarouselBase(LitElementWithUtils) {
    constructor() {
        super(...arguments);
        this._headlineId = (() => {
            uidCounter += 1;
            return `cgp-headline-${uidCounter}`;
        })();
        this.navTemplate = '#number1# / #number2#';
        this.divider = false;
        this.alignTitle = CardsGalleryPlusHeadlineAlign.CENTER;
        this.headlineColor = CardsGalleryPlusHeadlineColor.BLACK;
        this.headlineSize = CardsGalleryPlusHeadlineSize.LARGE;
        this.templateType = CardsGalleryPlusTemplateType.CLASSIC;
        this.displayType = CardsGalleryPlusDisplayType.CAROUSEL;
        this.componentType = '';
        this._hasHeadline = false;
        this._cardCount = 0;
        this._gridCols = 3;
    }
    firstUpdated() {
        setTimeout(() => {
            var _a;
            const isMulticomponent = this.componentType === 'multicomponent';
            const isGrid = this.displayType === CardsGalleryPlusDisplayType.GRID ||
                isMulticomponent;
            const count = this.querySelectorAll('[slot="slide-container"]').length;
            this._cardCount = count;
            if (!isGrid) {
                this.transformSlotsIntoSlides();
                this.initCarousel((props, ctx) => {
                    var _a, _b;
                    const settings = getGenericCarouselSettings(props, ctx);
                    const bp = (_a = settings.breakpoints) !== null && _a !== void 0 ? _a : {};
                    const slotsCount = ctx.numberOfSlots;
                    const isClassicTwoCards = this.templateType === CardsGalleryPlusTemplateType.CLASSIC &&
                        slotsCount === 2;
                    // Cap slidesPerView to actual card count so no empty slots appear
                    const spvTablet = isClassicTwoCards ? 3 : Math.min(2, slotsCount);
                    const spvLaptop = isClassicTwoCards ? 3 : Math.min(3, slotsCount);
                    const spvDesktop = isClassicTwoCards ? 3 : Math.min(4, slotsCount);
                    return Object.assign(Object.assign({}, settings), { spaceBetween: 16, breakpoints: {
                            768: Object.assign(Object.assign({}, bp[768]), { slidesPerView: spvTablet, slidesPerGroup: spvTablet, spaceBetween: 16 }),
                            900: Object.assign(Object.assign({}, bp[900]), { slidesPerView: spvLaptop, slidesPerGroup: spvLaptop, spaceBetween: 16 }),
                            1024: Object.assign(Object.assign({}, ((_b = bp[900]) !== null && _b !== void 0 ? _b : {})), { slidesPerView: spvLaptop, slidesPerGroup: spvLaptop, spaceBetween: 32 }),
                            1200: Object.assign(Object.assign({}, bp[1200]), { slidesPerView: spvDesktop, slidesPerGroup: spvDesktop, spaceBetween: 32 }),
                            1920: Object.assign(Object.assign({}, bp[1920]), { slidesPerView: spvDesktop, slidesPerGroup: spvDesktop, spaceBetween: 32 }),
                        } });
                });
                this._initAriaHiddenObserver();
            }
            else {
                const isClassicTwoCardsGrid = this.templateType === CardsGalleryPlusTemplateType.CLASSIC && count === 2;
                // Keep classic 2-card grid proportions aligned with paginated presentation.
                if (isClassicTwoCardsGrid) {
                    this._gridCols = 3;
                }
                else if (count <= 3) {
                    this._gridCols = Math.max(count, 1);
                }
                else if (count === 4) {
                    this._gridCols = 2;
                }
                else {
                    this._gridCols = 3;
                }
                this.style.setProperty('--cgp-cols', String(this._gridCols));
                this.style.setProperty('--cgp-col-w-tablet', `calc((100% - ${(this._gridCols - 1) * 16}px) / ${this._gridCols})`);
                this.style.setProperty('--cgp-col-w-laptop', `calc((100% - ${(this._gridCols - 1) * 32}px) / ${this._gridCols})`);
                this.setAttribute('cardcount', String(count));
                this.querySelectorAll('[slot="slide-container"]').forEach(card => {
                    card.setAttribute('role', 'listitem');
                });
                this._initGridHeightObserver();
            }
            setDataAttributes(this, 'headline', null);
            setLineClamp(this, 80, null);
            const headlineSlot = this.shadowRoot.querySelector('slot[name="headline"]');
            this._hasHeadline = ((_a = headlineSlot === null || headlineSlot === void 0 ? void 0 : headlineSlot.assignedElements().length) !== null && _a !== void 0 ? _a : 0) > 0;
        }, 0);
    }
    disconnectedCallback() {
        var _a, _b;
        super.disconnectedCallback();
        (_a = this._ariaObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        (_b = this._gridHeightObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
    _initGridHeightObserver() {
        const cards = Array.from(this.querySelectorAll('cards-gallery-plus-card'));
        if (cards.length < 2)
            return;
        let rafId = null;
        const syncHeights = () => {
            cards.forEach(c => c.style.removeProperty('height'));
            const maxHeight = Math.max(...cards.map(c => c.offsetHeight));
            if (maxHeight > 0) {
                cards.forEach(c => c.style.setProperty('height', `${maxHeight}px`));
            }
        };
        const scheduleSync = () => {
            if (rafId !== null)
                cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(syncHeights);
        };
        this._gridHeightObserver = new ResizeObserver(scheduleSync);
        this._gridHeightObserver.observe(cards[0]);
        window.addEventListener('resize', scheduleSync, { passive: true });
        scheduleSync();
        const origDisconnect = this.disconnectedCallback.bind(this);
        this.disconnectedCallback = () => {
            window.removeEventListener('resize', scheduleSync);
            if (rafId !== null)
                cancelAnimationFrame(rafId);
            origDisconnect();
        };
    }
    _initAriaHiddenObserver() {
        var _a;
        const swiperEl = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
        if (!swiperEl)
            return;
        this._ariaObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const card = entry.target;
                const isVisible = entry.isIntersecting;
                card.inert = !isVisible;
                card.setAttribute('aria-hidden', String(!isVisible));
                if (isVisible) {
                    card.removeAttribute('tabindex');
                }
                else {
                    card.setAttribute('tabindex', '-1');
                }
            });
        }, { root: swiperEl, threshold: 0.9 });
        this.shadowRoot
            .querySelectorAll('cards-gallery-plus-card')
            .forEach(card => this._ariaObserver.observe(card));
    }
    // @ts-ignore
    render() {
        var _a;
        const isRtl = this.rtl || isRTL();
        const isFloating = this.templateType === CardsGalleryPlusTemplateType.FLOATING;
        const isClassicTwoCards = this.templateType === CardsGalleryPlusTemplateType.CLASSIC &&
            this._cardCount === 2;
        const isMulticomponent = this.componentType === 'multicomponent';
        const isGrid = this.displayType === CardsGalleryPlusDisplayType.GRID ||
            isMulticomponent;
        const mainContent = isGrid
            ? $ `<ul class="cards-gallery-plus__grid" role="list"><slot name="slide-container"></slot></ul>`
            : $ `<div class="swiper cards-gallery-plus__carousel ${isFloating ? 'cards-gallery-plus__carousel--floating-pad' : ''}"><ul class="swiper-wrapper" role="list"></ul><slot name="slide-container"></slot></div><carousel-navigation ?rtl="${isRtl}" nextText="${this.nextText}" previousText="${this.previousText}"></carousel-navigation>`;
        return this.renderCarousel($ `<section class="${isMulticomponent ? '' : 'generic-carousel-container'} cards-gallery-plus cards-gallery-plus--${this.templateType} ${isClassicTwoCards ? 'cards-gallery-plus--classic-two-cards' : ''} ${isMulticomponent ? 'cards-gallery-plus--multicomponent' : ''} ${this.divider ? 'cards-gallery-plus--divider' : ''} ${isRtl ? 'cards-gallery-plus--rtl rtl' : ''} ${isMulticomponent ? '' : (_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}" aria-label="${l(!isGrid && !this._hasHeadline ? 'Carousel' : undefined)}" aria-labelledby="${l(this._hasHeadline ? this._headlineId : undefined)}" aria-roledescription="${l(!isGrid ? 'carousel' : undefined)}" role="${l(!isGrid && this._hasHeadline ? 'group' : undefined)}"><div class="header cards-gallery-plus__header ${!this._hasHeadline ? 'no-heading' : ''}"><slot name="headline" id="${this._headlineId}" class="${this.headlineColor} ${this.headlineSize} headline headline-${this.alignTitle}"></slot><slot name="cta"></slot></div>${mainContent}</section>`);
    }
};
CardsGalleryPlus.ownStyles = css_248z;
CardsGalleryPlus.styles = [LitElementWithUtils.styles || [], css_248z, css_248z$1];
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "navTemplate", void 0);
__decorate([
    e({ type: Boolean })
], CardsGalleryPlus.prototype, "divider", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "alignTitle", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "headlineColor", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "headlineSize", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "templateType", void 0);
__decorate([
    e({ type: String, reflect: true })
], CardsGalleryPlus.prototype, "displayType", void 0);
__decorate([
    e({ type: String })
], CardsGalleryPlus.prototype, "componentType", void 0);
__decorate([
    t()
], CardsGalleryPlus.prototype, "_hasHeadline", void 0);
__decorate([
    t()
], CardsGalleryPlus.prototype, "_cardCount", void 0);
CardsGalleryPlus = __decorate([
    n('cards-gallery-plus')
], CardsGalleryPlus);
// CPD-ON

export { CardsGalleryPlus };
